import React from 'react';
import './SettingsPage.css';
import ThemeSelector from './ThemeSelector';
// import { useNavigate } from 'react-router-dom';

const SettingsPage: React.FC = () => {
  //const navigate = useNavigate();

  return (
    <div className="settings-page">

      <div className="settings-content">
        <div className="settings-section">
          <h2>🎨 Theme </h2>
          <p className="section-description">
            Customize your light and dark theme preferences
          </p>
          <ThemeSelector />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
